import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Form, Input, Button, message, DatePicker, Spin } from "antd";
import "dayjs/locale/en-gb"; // Changed to English locale
import locale from "antd/es/date-picker/locale/en_GB"; // Changed to English locale
import BackRouteButton from "src/common/components/BackRouteButton";

import "./index.css";

export default ({ createAnalysis, profile }) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    values.creatorId = profile._id;

    const result = await createAnalysis(values);
    if (result.success) {
      form.resetFields();
      message.success("Analysis successfully recorded!");
      history.goBack();
    } else {
      message.error(result.message || "Failed to save analysis!");
      setLoading(false);
    }
  };

  return (
    <div className="common-container">
      <Spin spinning={loading}>
        <BackRouteButton />
        <h4 className="common-title--large">Record Analysis</h4>
        <Form
          requiredMark={false}
          layout="vertical"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
            label="Date:"
            name="date"
            rules={[
              {
                required: true,
                message: "Please select the analysis date!",
              },
            ]}
          >
            <DatePicker
              size="small"
              locale={locale}
              format="DD.MM.YYYY"
              style={{
                width: "50%",
              }}
            />
          </Form.Item>
          <Form.Item label="Flour Data:" name="flour">
            <Input.TextArea />
          </Form.Item>
          <Form.Item label="Wheat Data:" name="wheat">
            <Input.TextArea />
          </Form.Item>

          <Form.Item>
            <Button type="primary" block size="medium" htmlType="submit">
              Record
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </div>
  );
};
